// Lane 1405 v3: where the Build a workbook button's offer goes (Home.js).
// Plain JavaScript with no imports, so check 98 runs it in node.

/**
 * Lane 1408 (Ryan, D1): ONE workbook button, the one by the chat box. An
 * answer's own offer (quiet, asked for in words, or the retry offer after a
 * failed plan) is never drawn under it; only an offer the button put on the
 * answer is, because that one carries the build's progress row. The button
 * retries a failed plan itself (chat_action_buttons.retry_offer_id).
 */
export function showsAnswerOffer(message) {
  return message.reportOfferFromButton === true;
}

/**
 * Puts a workbook offer on the answer the server named (`answerTurnId`, the
 * answer turn's client turn id), wherever it sits in the chat. Returns
 * { outcome, messages }:
 * - 'started': the answer now holds the offer, set to start at once;
 * - 'already': the answer already holds this offer and its workbook has started
 *   (consumed or planned), so nothing changes: a second click never starts or
 *   shows the same workbook again (Codex S4 fix r1);
 * - 'missing': that answer is not in these messages.
 * Only an ordinary chat answer takes it.
 */
export function placeOfferOnAnswer(messages, offer, answerTurnId) {
  const isTarget = m => m.role === 'assistant' && m.answerOrigin === 'mirror' && !m.error
    && typeof answerTurnId === 'string' && answerTurnId !== '' && m.replyToMessageId === answerTurnId;
  const target = messages.find(isTarget);
  if (!target) return { outcome: 'missing', messages };
  const same = target.reportOffer && offer && target.reportOffer.offer_id === offer.offer_id;
  if (same && (target.reportOfferConsumed || target.reportPlan)) return { outcome: 'already', messages };
  return {
    outcome: 'started',
    messages: messages.map(m => (m === target
      ? { ...m, reportOffer: offer, reportOfferConsumed: false, reportOfferAutoStart: true,
        reportOfferFromButton: true }
      : m)),
  };
}
